import { useEffect, useState } from "react";
import { createHomeSlider, type HomeSlider } from "../../../types/HomeSlider";
import { useLoadingStore } from "../../../store/loadingStore";
import Sliders from "../../../components/Config/HomeConfig/Sliders/Sliders";
import { executeDelete, executeFetch, executePost, executePostForm, executePutForm } from "../../../helper/Api";
import { Exception } from "sass";
import useToastStore from "../../../store/toastStore";

export default function HomeSliders() {
    // States
    const [sliders, setSliders] = useState<HomeSlider[]>([]);
    const [sliderCounter,setSliderCounter] = useState<number>(0);
    const {setLoading} = useLoadingStore();
    const {showToast} = useToastStore();

    //Actions
    const handleAddSlider = async () => {
      const newSlider = createHomeSlider();
      newSlider.index = sliderCounter + 1;
      setLoading(true);
      const addSliderResult = await executePost<HomeSlider,HomeSlider>('Settings/AddHomeSlider',newSlider,{admin:true});
      if(addSliderResult.error){
         showToast('Something went wrong adding slider!','error')
         console.error(addSliderResult.error.message);
      }else{
        setSliders([...sliders, addSliderResult.data]);
      }
      setLoading(false);
    };

    const handleRemoveSlider = async (id: string) => {
      setLoading(true);
      const deleteSliderResult = await executeDelete('Settings/DeleteHomeSlider',id,{admin:true});
      if(deleteSliderResult.error){
         showToast('Something went wrong deleting slider!','error');
         console.error(deleteSliderResult.error.message);
      }else{
        setSliders(sliders.filter(slider => slider.id !== id));
      }
      setLoading(false);
    };


    const handleUpdateSlider = (updatedSlider: HomeSlider) => {
      setSliders(sliders.map(slider => 
        slider.id === updatedSlider.id ? updatedSlider : slider
      ));
    };

    const getFileNameFromUrl = (url: string) => {
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1];
    };

 

    const updateSlider = async (homeSlider : HomeSlider,desktop : File | null,mobile : File | null) => {
          const payLoad = new FormData();
          if (homeSlider.desktop) {
            homeSlider.desktop = getFileNameFromUrl(homeSlider.desktop);
          }
          if (homeSlider.mobile) {
            homeSlider.mobile = getFileNameFromUrl(homeSlider.mobile);
          }
          payLoad.append('homeSliderString',JSON.stringify(homeSlider));
          payLoad.append('desktop',desktop);
          payLoad.append('mobile',mobile);
          setLoading(true);
        const updateSliderResult = await executePutForm<HomeSlider>('Settings/UpdateHomeSlider',payLoad,{admin:true});
        if(updateSliderResult.error){
          showToast('Something went wrong updating slider!','error')
          console.error(updateSliderResult.error.message);
        }else{
          showToast('Successfully update the slider!','success')
          setSliders(prev =>
            prev.map(s => s.id === updateSliderResult.data?.id ? updateSliderResult.data! : s)
          );
        }
        setLoading(false);      
    }

    //Effects

    useEffect(()=>{
      const fetchHomeSliders =async () => {
        setLoading(true);
        //fetch home sliders
        const homeSlidersResp = await executeFetch<HomeSlider[]>('Settings/GetHomeSliders',{admin:true});
        if(homeSlidersResp.error){
           console.error(homeSlidersResp.error.message)
        }else{
          const sortedSliders = homeSlidersResp.data.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
          setSliders(sortedSliders);
          setSliderCounter(homeSlidersResp.data.length)
        }
        setLoading(false);
      }
      fetchHomeSliders();
    },[])

    useEffect(()=>{
      if(sliderCounter!=sliders.length){
        setSliderCounter(sliders.length)
      }
    
    },[sliders])
    useEffect(()=>{
      const sortedSliders = sliders.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      setSliders(sortedSliders)
    },[sliderCounter])
    
    return (
        <div className="admin-section home-slider">
        <Sliders
          sliders={sliders}
          onAdd={handleAddSlider}
          onRemove={handleRemoveSlider}
          onUpdate={handleUpdateSlider}
          updateSlider={updateSlider}
        />
        </div>
    );
  };
  
  